import { BaseQueryFn, FetchArgs, FetchBaseQueryError, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import moment from 'moment';
import { REACT_APP_API_ISF, archLevel } from 'src/data/config';
import { RootState } from 'src/store/index';

export const baseQueryISF: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  isfDocLevelApi,
  extraOptions
) => {
  const baseUrldata: any = (isfDocLevelApi.getState() as RootState)?.site?.siteInfo?.site?.hospital_slug_url;
  const baseUrl = `${REACT_APP_API_ISF}${archLevel == 'sponsor' ? `${baseUrldata}/isf` : ''}`;
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = ((getState() as RootState)?.user?.user as any)?.siteToken;
      const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      if (sponsor) {
        headers.set('sponsor', sponsor);
      }
      headers.set('sponsor_token', `${(getState() as RootState).user?.user?.sponsorToken}`);
      headers.set('user_date_time', moment().format());
      return headers;
    }
  });
  return rawBaseQuery(args, isfDocLevelApi, extraOptions);
};
